import axios from '@/plugins/axios'

const destroySubscription = async id => {
  try {
    const response = await axios.post(`subscriptions/${id}`, {
      _method: 'DELETE'
    })
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

const getSubscriptions = async ({ page = 1, type }) => {
  try {
    const params = {
      page: page,
      type: type
    }
    const response = await axios.get('subscriptions', {
      params: params
    })
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

const getSubscription = async id => {
  try {
    const response = await axios.get(`subscriptions/${id}`)
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

const updateSubscription = async (id, {
  // eslint-disable-next-line camelcase
  payment_method,
  // eslint-disable-next-line camelcase
  card_id = null
}) => {
  try {
    const params = {
      payment_method: payment_method,
      _method: 'PUT'
    }

    // eslint-disable-next-line camelcase
    if (payment_method === 'credit_card') params.card_id = card_id

    const response = await axios.post(`subscriptions/${id}`, params)
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

export default {
  destroySubscription,
  getSubscription,
  getSubscriptions,
  updateSubscription
}
